package one.devsbox.www.ui.company

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.Color
import one.devsbox.www.provider.LocalMeProvider
import one.devsbox.www.provider.MeProvider
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.viewmodel.viewModel

class ListingCompanyCtx private constructor(
    val vm: ListingCompanyVM,
    val nav: Navigation,
    val me: MeProvider,
    val colorPrimaryContainer: Color,
    val colorSecondaryContainer: Color
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): ListingCompanyCtx {
            val nav = LocalNavigation.current
            val vm = nav.viewModel(ListingCompanyVM::class)
            val me = LocalMeProvider.current
            val colorPrimary = MaterialTheme.colorScheme.primary
            val colorSecondary = MaterialTheme.colorScheme.secondary
            return remember {
                ListingCompanyCtx(
                    vm = vm,
                    nav = nav,
                    me = me,
                    colorPrimaryContainer = colorPrimary,
                    colorSecondaryContainer = colorSecondary
                ).apply {
                    vm.setup(this)
                }
            }
        }
    }
}
